import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../services/snackbar.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-challenge',
  templateUrl: './edit-challenge.component.html',
  styleUrls: ['./edit-challenge.component.css']
})
export class EditChallengeComponent implements OnInit {


  formdata;
  challengeId;
  challengeName;
  timeDuration;
  submitted;
  formdetail;
  invalid: boolean = false;
  apiBaseUrl: string = environment.url;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private snackbar: SnackbarService) { }

  ngOnInit() {
    this.challengeId = this.route.snapshot.params.id;

    this.formdata = new FormGroup({
      challengeName: new FormControl("", [Validators.required]),
      timeDuration: new FormControl("", [Validators.required]),
      timeDurationIn: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
    });

    this.http.post(this.apiBaseUrl + 'v1/getChallengeAdminForEdit', { id: this.challengeId }).subscribe((data: any) => {
      if (data.status == 200) {

        this.formdata.setValue({
          'challengeName': data.data[0].challengeName,
          'timeDuration': data.data[0].timeDuration,
          'timeDurationIn': data.data[0].timeDurationIn,
          'description': data.data[0].description ? data.data[0].description : ""
        })
      }
    })

  }

  get f() { return this.formdata.controls; }

  editChallengeByAdmin(data) {
    this.submitted = true;
    if (this.formdata.invalid) {
      return;
    }
    this.formdetail = {
      'challengeId': this.challengeId,
      'challengeName': data.challengeName,
      'timeDuration': data.timeDuration,
      'timeDurationIn': data.timeDurationIn,
      'description': data.description
    }

    this.http.post(this.apiBaseUrl + 'v1/editChallengeAdmin', this.formdetail).subscribe((data: any) => {
      if (data.status == 200) {
        this.router.navigate(['/workout-challenges']);
        this.snackbar.successSnackBar("Challenge successfully updated", '');

      }
      else {
        this.invalid = true;
      }
    })
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}

